import React, { memo } from 'react';
import HintWrapper from '../HintWrapper';
import './Aoe2UnitsHint.scss';

const Aoe2UnitsHint = memo(({ attemptsCount, currentUnit, gameWon, isHintRevealed, onRevealHint }) => {
  return (
    <HintWrapper
      attemptsCount={attemptsCount}
      currentItem={currentUnit}
      gameWon={gameWon}
      isHintRevealed={isHintRevealed}
      onRevealHint={onRevealHint}
      cssPrefix="aoe2-units-game"
      hintProperty="hint"
      hintLabel="Exact Cost"
      showPostWinHint={false}
      unlockThreshold={5}
    >
      {/* Custom content renderer for hint cost */}
      {currentUnit && currentUnit.hint && (
        <>
          <div><strong>Exact Cost:</strong></div>
          <div className="aoe2-units-game__hint-cost-text">{currentUnit.hint}</div>
        </>
      )}
    </HintWrapper>
  );
});

export default Aoe2UnitsHint;